<template>
  <div class="pie-chart-skeleton-loader">
    <apex-chart
      type="donut"
      height="350"
      :options="chartOptions"
      :series="chartSeries"
    ></apex-chart>
  </div>
</template>

<script>
import ApexChart from 'vue-apexcharts';
import { random } from 'lodash';

export default {
  name: 'PieChartSkeletonLoader',

  props: {
    quantitySeries: {
      type: Number,
      required: false,
      default: 3,
    },
  },

  data() {
    return {
      chartSeries: this.generateChartSeries(),
    };
  },

  methods: {
    /**
     * Generate a random chart series.
     *
     * @returns {number[]}
     */
    generateChartSeries() {
      return Array(this.quantitySeries).fill('').map(() => random(1, 20));
    },
  },

  computed: {
    chartOptions() {
      return {
        chart: {
          height: window.screen.availHeight > 768 ? 350 : 300,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
          },
        },
        colors: ['#DDDBDD'],
        labels: Array(this.quantitySeries).fill(''),
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          enabled: false,
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            },
          },
        },
        legend: {
          position: 'right',
          labels: {
            colors: ['#DDDBDD'],
          },
          formatter() {
            return '<span style="width:107px;height:14px;display:inline-block;background-color:#DDDBDD;"></span>';
          },
        },
      };
    },
  },

  mounted() {
    this.intervalGenerateChartSeries = setInterval(() => {
      this.chartSeries = this.generateChartSeries();
    }, 2000);
  },

  beforeDestroy() {
    clearInterval(this.intervalGenerateChartSeries);
  },

  components: {
    ApexChart,
  },
};
</script>

<style lang="scss" scoped>
.pie-chart-skeleton-loader {
  @apply overflow-hidden;

  &:after {
    @apply absolute;
    @apply top-0;
    @apply right-0;
    @apply bottom-0;
    @apply left-0;
    transform: translateX(-100%);
    background-image: linear-gradient(90deg, rgba(#fff, 0) 0, rgba(#fff, 0.2) 20%, rgba(#fff, 0.5) 60%, rgba(#fff, 0));
    animation: skeleton-loader 3s infinite;
    content: '';
  }
}
</style>
